import styled from 'styled-components';

export const StyledDiv = styled.div`
  cursor: pointer;
  border: 5px solid transparent;
  margin-left: -5px;
  box-sizing: border-box;
  width: fit-content;
`;
